import { render, staticRenderFns } from "./UserSettingsComponent.vue?vue&type=template&id=0e1fa50f&"
import script from "./UserSettingsComponent.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UserSettingsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports